module.exports = __webpack_public_path__ + "static/media/Java Logo.50a62608.png";